'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./MapPreviewOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapPreviewOverlay = function MapPreviewOverlay(_ref) {
    var onClick = _ref.onClick,
        show = _ref.show;

    if (!show) return null;

    return _react2.default.createElement(
        'div',
        { className: 'MapPreviewOverlay' },
        _react2.default.createElement(
            'div',
            { className: 'launch-button-hit-area', onClick: onClick },
            _react2.default.createElement(
                'div',
                { className: 'launch-button' },
                _react2.default.createElement(
                    'span',
                    { className: 'launch-text' },
                    'Enable map'
                )
            )
        )
    );
};

// Styles
// Lib


MapPreviewOverlay.propTypes = {
    onClick: _propTypes2.default.func,
    show: _propTypes2.default.bool
};

exports.default = MapPreviewOverlay;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/map/MapPreviewOverlay.js
// module id = 2015
// module chunks = 0